(function(){
'use strict';
const $=(s,c=document)=>c.querySelector(s);
const $$=(s,c=document)=>[...c.querySelectorAll(s)];
const on=(el,ev,fn)=>el&&el.addEventListener(ev,fn);
const isPage=(...t)=>t.some(p=>document.body.classList.contains('template-'+p));

function initTrustBadges(){
  if(!isPage('product'))return;
  const atcBtn=$('.product-form__submit');
  if(!atcBtn||$('.ma-trust'))return;
  const wrap=document.createElement('div');
  wrap.className='ma-trust';
  wrap.innerHTML=`<div class="ma-trust-item"><span class="ma-trust-icon">\uD83D\uDD12</span><span>Paiement s\u00e9curis\u00e9</span></div><div class="ma-trust-item"><span class="ma-trust-icon">\uD83D\uDE9A</span><span>Livraison mondiale</span></div><div class="ma-trust-item"><span class="ma-trust-icon">\u21A9</span><span>Retours 14j</span></div>`;
  const parent=atcBtn.closest('form,.cart-functions,.product-actions')||atcBtn.parentElement;
  parent?.insertAdjacentElement('afterend',wrap);
}

/* UPSELL PANIER — produits OVER */
function initCartUpsell(){
  const cartBody=$('#site-cart .site-nav-container-last,.cart-form');
  if(!cartBody||$('.ma-upsell'))return;
  // Upsell avec Tee-Shirt Rose OVER
  fetch('/products/tee-shirt-over-cropped-boxy-fit.js').then(r=>r.json()).then(product=>{
    const price=(product.price/100).toFixed(2).replace('.',',');
    const img=product.featured_image||'';
    const variant=product.variants?.[0]?.id;
    fetch('/cart.js').then(r=>r.json()).then(cart=>{
      const alreadyIn=cart.items?.some(i=>i.product_id===product.id);
      if(alreadyIn)return;
      const box=document.createElement('div');
      box.className='ma-upsell';
      box.innerHTML=`<div class="ma-upsell-label">Compl\u00e8te ton OVER</div><div class="ma-upsell-row"><div class="ma-upsell-img">${img?`<img src="${img}" alt="${product.title}">`:''}  </div><div class="ma-upsell-info"><div class="ma-upsell-name">${product.title}</div><div class="ma-upsell-price">${price} \u20ac</div></div><button class="ma-upsell-btn" data-variant="${variant}">+ Ajouter</button></div>`;
      cartBody.appendChild(box);
      on(box.querySelector('.ma-upsell-btn'),'click',async function(){
        try{
          await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(this.dataset.variant),quantity:1})});
          this.textContent='\u2713 Ajout\u00e9';
          this.style.background='#1a5c1a';
          box.style.opacity='.5';
          setTimeout(()=>box.remove(),2000);
        }catch(e){this.textContent='R\u00e9essayer';}
      });
    });
  }).catch(()=>{});
}

function init(){
  initTrustBadges();
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-js-site-cart-sidebar],[href="/cart"]')){
      setTimeout(()=>{initCartUpsell();},800);
    }
  });
}

if(document.readyState!=='loading')init();
else document.addEventListener('DOMContentLoaded',init);
})();